import store from "../../redux/store";

function GetUserIsInternal(avdid) {
  if (!avdid) return false;
  var state = store.getState();
  if (!state || !state.user.user || !state.user.user.id) return false;
  const avd = state.user.user.avdelnings.find((a) => a.id === avdid);
  return avd?.internalUser ?? false;
}

store.subscribe(GetUserIsInternal);

export default GetUserIsInternal;
